import React, { useEffect, useState } from "react";
import config from "../../config";
const Icon = ({ iconClass, name, size = 16, style }) => {
  const [Icon, setIcon] = React.useState("");

  React.useEffect(() => {
    let isMounted = true;
    fetch(config.assetPath + `/icons/${name}.svg`)
      .then((res) => res.text())
      .then((res) => {
        if (isMounted) {
          if (res.startsWith("<svg") || res.startsWith("<?xml"))
            return setIcon(res);
          console.error(`Icon: "${name}.svg" not found in /icons`);
          return setIcon("");
        }
      });
    return () => {
      isMounted = false;
    };
  }, [name]);

  if (!Icon) return null;

  return (
    <i
      datalocation={config.assetPath + `/icons/${name}.svg`}
      className={iconClass + " hgs-custom-icons "}
      style={style}
      dangerouslySetInnerHTML={{ __html: Icon }}
    />
  );
};
export default Icon;
